<template>
  <svg :width="width" :height="height" viewBox="0 0 91 91" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M88.6962 45.2821C89.0926 45.6666 89.1024 46.2997 88.7179 46.6961L70.5117 65.4713L63.2509 57.2618C62.8851 56.8481 62.9238 56.2162 63.3375 55.8503C63.7512 55.4844 64.3832 55.5231 64.7491 55.9368L70.5792 62.5287L87.2821 45.3039C87.6666 44.9074 88.2997 44.8976 88.6962 45.2821Z"
      fill="#FF0064"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.4494 45.27L17.487 45.5413C14.7557 46.3114 13.1232 47.8748 12.4142 50.2415C12.2473 50.7989 12.0993 51.8429 11.9982 53.4517L11.9355 54.4497L9.93945 54.3243L10.0022 53.3262C10.1038 51.7092 10.2599 50.4637 10.4984 49.6676C11.4262 46.5704 13.6332 44.55 16.9442 43.6164L17.9067 43.345L18.4494 45.27ZM25.7897 43.2866L26.7581 43.536C30.116 44.4008 32.3989 46.3416 33.4097 49.3756C33.6932 50.2265 33.8778 51.5714 33.9979 53.3205L34.0663 54.3181L32.071 54.4551L32.0025 53.4574C31.883 51.7156 31.7081 50.5956 31.5123 50.0078C30.7475 47.7122 29.0622 46.1947 26.2593 45.4728L25.2909 45.2234L25.7897 43.2866Z"
      fill="#05070F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22 35C19.2386 35 17 37.2386 17 40C17 42.7614 19.2386 45 22 45C24.7614 45 27 42.7614 27 40C27 37.2386 24.7614 35 22 35ZM15 40C15 36.134 18.134 33 22 33C25.866 33 29 36.134 29 40C29 43.866 25.866 47 22 47C18.134 47 15 43.866 15 40Z"
      fill="#05070F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7 23C5.34315 23 4 24.3431 4 26V64C4 65.6569 5.34315 67 7 67H67C67.5523 67 68 67.4477 68 68C68 68.5523 67.5523 69 67 69H7C4.23858 69 2 66.7614 2 64V26C2 23.2386 4.23858 21 7 21H73C75.7614 21 78 23.2386 78 26V47.875C78 48.4273 77.5523 48.875 77 48.875C76.4477 48.875 76 48.4273 76 47.875V26C76 24.3431 74.6569 23 73 23H7Z"
      fill="#05070F"
    />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M32 31H12V55H32V31ZM10 29V57H34V29H10Z" fill="#05070F" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M39 31H69V35H39V31Z" fill="#05070F" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M39 38H57V40H39V38Z" fill="#05070F" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M39 43H61V45H39V43Z" fill="#05070F" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M39 53H59V55H39V53Z" fill="#05070F" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M39 48H55V50H39V48Z" fill="#05070F" />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'IdVerificationIllustration',
  props: {
    width: {
      type: Number,
      default: 91,
    },
    height: {
      type: Number,
      default: 91,
    },
  },
};
</script>
